<body>
    <div class="container">
        <h1 class="title">Planning Table Form</h1>
        <form [formGroup]="form" (click)="stopPropagation($event)">
            <div class="trip-details">
                <label class="labels">VIAGEM</label>
                <input class="input-box form-control" type="text" placeholder="Nome da viagem" maxlength="20"
                    formControlName="tripName">
            </div>
            <div class="trip-details">
                <label class="labels">CHEGADA</label>
                <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                    formControlName="arrivalLCB" (input)="formatTime($event)">
            </div>
            <div class="trip-details">
                <label class="labels">SAÍDA</label>
                <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                    formControlName="departureLCB" (input)="formatTime($event)">
            </div>

            <div class="trip-type">
                <legend class="labels">Classificação</legend>
                <div class="category">
                    <label for="dot-1">
                        <input type="radio" class="dot one" formControlName="classification" value="time-table">
                        <span>Time Table</span>
                    </label>
                    <label for="dot-2">
                        <input type="radio" class="dot two" formControlName="classification" value="mg">
                        <span>MG</span>
                    </label>
                    <label for="dot-3">
                        <input type="radio" class="dot three" formControlName="classification" value="container">
                        <span>Container</span>
                    </label>
                </div>
            </div>

            <div class="common-trip">
                <div class="form-group">
                    <label class="labels">Empresa</label>
                    <select class="input-box form-control" formControlName="company">
                        <option *ngFor="let company of companies" [value]="company">{{company}}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="labels">Tipo</label>
                    <select class="input-box form-control" formControlName="tripType">
                        <option *ngFor="let tripType of tripTypes" [value]="tripType">{{tripType}}</option>
                    </select>
                </div>
            </div>

            <div class="action-buttons">

                <button (click)="isNewTrip() ? submitForm() : updateTrip()" class="btn-save">
                    {{ isNewTrip() ? 'Salvar' : 'Atualizar' }}
                </button>
                <button (click)="resetForm()" class="btn-clear">Limpar</button>
            </div>
            <div class="close-div">
                <button (click)="onClose()" class="btn-cs">Sair</button>
            </div>
        </form>
    </div>
</body>